import { Fade } from "react-awesome-reveal";
const Thought = ({ text, sectionBg = false }) => (
	<section
		className={`section-parallax-3 call-to-action-section section ${
			sectionBg ? "section-bg" : ""
		}`}
		id="call-to-action-section"
	>
		<Fade direction="up" cascade={true} damping={0.5} delay={400} triggerOnce>
			<div className="container">
				<p
					style={{
						fontFamily: "monospace",
						borderRadius: "2em",
						boxShadow: "2px 0 20px 1px #ff8059",
						padding: "2em",
						margin: "0",
					}}
				>
					<strong>{text}</strong>
				</p>
			</div>
		</Fade>
	</section>
);
export default Thought;
